<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal">×</button>
    <h4 class="modal-title">{{TR "Alarm konfigurieren"}}</h4>
</div>
<div class="modal-body">
    {{ERROR_ROW errors.error}}
    {{#WIZARD wizardContext}}
        {{#unless model.ownerDeviceID}}
        {{#if filterConfig.isFilter}}
        {{#WIZARD-TAB (TR 'Filter')}}
            {{{DEVICE-FILTER filterConfig}}}
            <div id="js-category-alert" class="row hidden">
                <div class="col-xs-12">
                    <div class="alert alert-danger m-t-15">
                        {{TR 'Sie müssen eine Kategorie auswählen.'}}
                    </div>
                </div>
            </div>
        {{/WIZARD-TAB}}
        {{/if}}
        {{#WIZARD-TAB (TR 'Geräteauswahl')}}
            {{{DEVICE-SELECT filterConfig}}}
        {{/WIZARD-TAB}}
        {{/unless}}
        {{#WIZARD-TAB (TR 'Bedingungen')}}
            <div class="panel-group" id="accordion">
            {{#each model.conditions}}
              <div class="panel panel-default js-analog-row" data-index="{{@index}}">
                <div class="panel-heading">
                  <h4 class="panel-title">
                    <a data-toggle="collapse" data-parent="#accordion" href="#collapse{{@index}}" {{#unless selected}}class="collapsed"{{/unless}}>
                    <span class="js-label">{{name}}</span></a>
                  </h4>
                </div>
                <div id="collapse{{@index}}" class="panel-collapse collapse {{#if selected}}in{{/if}}">
                  <div class="panel-body">
                    <div class="form-group">
                        <div class="row">
                            <div class="col-lg-5 col-xs-10">
                                <label for="" class="control-label">{{TR "Wert"}}</label>
                                {{#SELECT this.line1key}}
                                <select name="measurement_1" class="selectpicker js-alarm-cond js-line-1" data-style="btn-white btn-sm">
                                <option value="">---</option>
                                {{#each ../deviceValues}}
                                    <option value="{{key}}">{{name}}</option>
                                {{/each}}
                                </select>
                                {{/SELECT}}
                            </div>
                            {{#COMPARE valueType '==' 0}}
                            <div class="col-lg-2 col-xs-2">
                                <label for="" class="control-label">{{TR "Op"}}</label>
                                {{#SELECT this.op}}
                                <select id="op" name="op" class="selectpicker js-alarm-cond js-op" data-style="btn-white btn-sm" {{#unless line1}}disabled{{/unless}}>
                                    <option value="">{{TR "keine"}}</option>
                                    {{#each ../calcOp}}
                                    <option title="{{TR name}}" value="{{value}}">{{{TR name}}}{{#if desc}} - {{TR desc}}{{/if}}</option>
                                    {{/each}}
                                </select>
                                {{/SELECT}}
                            </div>
                            {{/COMPARE}}
                            <div class="col-lg-5 col-xs-10">
                                {{#if op}}
                                <label for="" class="control-label">{{TR "Wert"}}</label>
                                {{#SELECT this.line2key}}
                                <select class="selectpicker js-alarm-cond js-line-2" data-style="btn-white btn-sm" {{#unless line1}}disabled{{/unless}}>
                                    <option value="">---</option>
                                    {{#each ../deviceValues}}
                                    {{#COMPARE unit '==' ../lineData.unit}}
                                        <option value="{{key}}">{{name}}</option>
                                    {{/COMPARE}}
                                    {{/each}}
                                </select>
                                {{/SELECT}}
                                {{/if}}
                            </div>
                        </div>
                        <div class="row m-t-5">
                            <div class="col-xs-5">
                                <label for="" class="control-label">{{TR "Vergleich"}}</label>
                            </div>
                            <div class="col-xs-5">
                                {{#if showRawValue}}
                                <div class="row">
                                    <div class="col-xs-6">
                                        <label for="" class="control-label">{{TR "Rohwert"}}</label>
                                    </div>
                                    <div class="col-xs-6">
                                {{/if}}
                                    <label for="" class="control-label">
                                        {{TR "Referenzwert"}}
                                        {{#COMPARE op '==' 'Z'}}
                                        (%)
                                        {{/COMPARE}}
                                        {{#COMPARE op '!=' 'Z'}}
                                        {{#if lineData.unit}}[{{lineData.unit}}]{{/if}}
                                        {{/COMPARE}}
                                    </label>
                                {{#if showRawValue}}
                                    </div>
                                </div>
                                {{/if}}
                            </div>
                        </div>
                        <div class="row m-t-5">
                            <div class="col-xs-5">
                                {{#SELECT this.comparison}}
                                <select class="selectpicker js-alarm-cond js-comparison" data-style="btn-white btn-sm" {{#unless line1}}disabled{{/unless}}>
                                    {{#each comparisonOpList}}
                                    <option value="{{k}}">{{o}}</option>
                                    {{/each}}
                                </select>
                                {{/SELECT}}
                            </div>
                            <div class="col-xs-5">
                                {{#COMPARE valueType '==' 2}}
                                    {{#SELECT this.valueConverted}}
                                    <select class="selectpicker js-value-status" multiple="multiple" data-style="btn-white btn-sm" {{#unless line1}}disabled{{/unless}}>
                                        {{#each this.statusValues}}
                                        <option value="{{value}}">{{text}}</option>
                                        {{/each}}
                                    </select>
                                    {{/SELECT}}
                                {{/COMPARE}}
                                {{#COMPARE valueType '==' 1}}
                                    {{#SELECT this.value}}
                                    <select class="selectpicker js-alarm-cond js-value-select" data-style="btn-white btn-sm" {{#unless line1}}disabled{{/unless}}>
                                        <option value="">---</option>
                                        {{#each this.enumItems}}
                                        <option value="{{value}}">{{text}}</option>
                                        {{/each}}
                                    </select>
                                    {{/SELECT}}
                                {{/COMPARE}}
                                {{#COMPARE valueType '==' 0}}
                                {{#if showRawValue}}
                                <div class="row">
                                    <div class="col-xs-6">
                                        <input
                                            type="text"
                                            class="form-control js-alarm-cond js-value input-sm"
                                            value="{{value}}"
                                            {{#unless line1}}disabled{{/unless}}
                                        >
                                        </input>
                                    </div>
                                    <div class="col-xs-6">
                                {{/if}}
                                        <input
                                            type="text"
                                            {{#if showRawValue}}readonly{{/if}}
                                            class="form-control {{#unless showRawValue}}js-alarm-cond js-value{{/unless}} input-sm"
                                            value="{{valueConverted}}"
                                            {{#unless line1}}disabled{{/unless}}
                                        >
                                        </input>
                                {{#if showRawValue}}
                                    </div>
                                </div>
                                {{/if}}
                                {{/COMPARE}}
                            </div>
                            <div class="col-xs-2">
                                <button class="btn btn-white js-delete pull-right"><i class="fa fa-trash"></i></button>
                            </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            {{/each}}
            </div>
            <br>
            <button class="btn btn-white" id="alarm-cond-add">
                <i class="fa fa-plus"></i>
            </button>
        {{/WIZARD-TAB}}
        {{#WIZARD-TAB (TR 'Alarm')}}
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-8">
                        <label for="alarm-name" class="control-label">{{TR "Bezeichnung"}}</label>
                        <input
                            class="form-control js-alarm-attr"
                            type="text"
                            name="name"
                            id="alarm-name"
                            value="{{model.name}}"
                            maxlength="100"
                        ></input>
                        {{#if errors.name}}
                        <ul class="parsley-errors-list filled" id="js-alarm-name-error">
                            <li class="parsley-required">{{TR "Alarmname ungültig"}} {{errors.name}}</li>
                        </ul>
                        {{/if}}
                    </div>
                    <div class="col-sm-4">
                        <label class="control-label">{{TR "Priorität"}}</label>
                        {{#SELECT model.priority}}
                            <select name="priority" class="js-alarm-attr selectpicker" data-style="btn-white form-control">
                            {{#each priorities}}
                                <option value="{{prio}}">{{name}}</option>
                            {{/each}}
                            </select>
                        {{/SELECT}}
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="checkbox checkbox-primary">
                    <input
                        id="is-active"
                        name="is_active"
                        type="checkbox"
                        {{#if model.is_active}}checked="checked"{{/if}}
                        class="js-alarm-attr"
                    >
                    <label for="is-active" class="control-label">{{TR "Der Alarm ist aktiv (scharf)."}}</label>
                </div>
            </div>
            <div class="form-group">
                <label for="trigger_time" class="control-label">{{TR "Alarmierung nach ..."}}</label>
                <div class="row">
                    <div class="col-xs-6">
                        {{#SELECT model.trigger_time_value}}
                        <select name="trigger_time_value" class="js-alarm-attr selectpicker" data-style="btn-white form-control">
                                <option value="0">{{TR "sofort"}}</option>
                            {{#each alarmDelays}}
                                <option value="{{value}}">{{display}}</option>
                            {{/each}}
                        </select>
                        {{/SELECT}}
                    </div>
                    {{#COMPARE model.trigger_time_value '>' 0}}
                    <div class="col-xs-6">
                        {{#SELECT model.trigger_time_unit}}
                        <select name="trigger_time_unit" class="js-alarm-attr selectpicker" data-style="btn-white">
                            <option value="1">{{TR "Minuten"}}</option>
                            <option value="60">{{TR "Stunden"}}</option>
                            <option value="1440">{{TR "Tagen"}}</option>
                        </select>
                        {{/SELECT}}
                    </div>
                    {{/COMPARE}}
                </div>
            </div>
            <div class="form-group">
                <div class="checkbox checkbox-primary">
                    <input id="notify-corrected" class="js-alarm-attr" name="notify_corrected" type="checkbox" {{#if model.notify_corrected}}checked="checked"{{/if}}>
                    <label for="notify-corrected" class="control-label">
                        {{TR "Eine Benachrichtigung bei Beseitigung des Alarmzustands schicken."}}
                    </label>
                </div>
            </div>
            <div class="form-group">
                {{#if showMailBoxOption}}
                <div class="row m-t-30 m-b-15">
                    <div class="col-sm-6">
                        <div class="radio checkbox-primary">
                            <input id="js-receiver-me" name="receiver" type="radio" class="js-alarm-attr js-alarm-receiver" {{#unless model.send_list}}checked{{/unless}} {{#if isReceiverMeDisabled}}disabled{{/if}}>
                            <label for="receiver"><b>{{TR "Benachrichtigung an mich"}}</b></label>
                        </div>
                        <div class="p-l-20">
               {{/if}}
                            <div class="checkbox checkbox-primary">
                                <input
                                    id="send_email"
                                    name="send_email"
                                    type="checkbox"
                                    class="js-alarm-attr js-receiver-me"
                                    {{#if model.send_email}}{{#unless model.send_list}}checked="checked"{{/unless}}{{/if}}
                                    {{#if model.send_list}}disabled{{/if}}
                                >
                                <label for="send_email" class="control-label">
                                    {{TR "Benachrichtigung per E-Mail an"}} {{email}}
                                </label>
                            </div>
                            <div class="checkbox checkbox-primary">
                                <input
                                    id="send_sms"
                                    name="send_sms"
                                    type="checkbox"
                                    {{#unless phone}}disabled{{/unless}}
                                    {{#if model.send_list}}disabled{{/if}}
                                    {{#if model.send_sms}}checked="checked"{{/if}}
                                    class="js-alarm-attr js-receiver-me"
                                >
                                <label for="send_sms" class="control-label">
                                    {{#if phone}}
                                    {{TR "Benachrichtigung per SMS an"}} {{phone}}
                                    {{else}}
                                    {{TR "Benachrichtigung per SMS"}}
                                    {{/if}}
                                </label>
                                {{#unless model.send_list}}
                                {{#unless phone}}
                                    <br>
                                    <small>{{TR "Bitte hinterlegen Sie die Telefonnummer in Ihrer Profileinstellung."}}</small>
                                {{/unless}}
                                {{/unless}}
                            </div>
                {{#if showMailBoxOption}}
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="radio checkbox-primary">
                            <input id="js-receiver-other" name="receiver" type="radio" class="js-alarm-attr js-alarm-receiver" {{#if model.send_list}}checked{{/if}} {{#if isReceiverBoxDisabled}}disabled{{/if}}>
                            <label for="receiver" class="control-label"><b>{{TR "Benachrichtigung an Postfach"}}</b></label>
                        </div>
                        <div class="p-l-20">
                            {{#if mailboxes}}
                                {{#SELECT model.send_list}}
                                <select id="js-mailing-list" name="send_list" multiple="multiple" class="js-alarm-attr js-receiver-other selectpicker {{#unless model.send_list}}disabled{{/unless}}" data-style="btn-white form-control">
                                    {{#each mailboxes}}
                                    <option value="{{id}}">{{name}}</option>
                                    {{/each}}
                                </select>
                                {{/SELECT}}
                            {{else}}
                                {{TR "Aktuell sind keine Postfächer konfiguriert."}}
                            {{/if}}
                        </div>
                    <div>
                </div>
                {{/if}}
            </div>
        </div>

        {{/WIZARD-TAB}}
    {{/WIZARD}}
    </div>

<div class="modal-footer">
    {{{WIZARD-BUTTONS wizardContext}}}
</div>
